import React from 'react';

import './sportsbook-spinner.scss';

export const SportsbookSpinner = () => (
  <div className="sportsbook-spinner position-absolute">
    <div />
    <div />
  </div>
);
